import { render, staticRenderFns } from "./ResourceSelect.vue?vue&type=template&id=b6adb7d2"
import script from "./ResourceSelect.vue?vue&type=script&lang=js"
export * from "./ResourceSelect.vue?vue&type=script&lang=js"
import style0 from "./ResourceSelect.vue?vue&type=style&index=0&id=b6adb7d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports